import { Component, EventEmitter, Output } from '@angular/core';
import { COMMON_MODULES, IMAGES_URL } from '@src/app/core/constants';
declare var $: any;

@Component({
  selector: 'app-error-dialog',
  standalone: true,
  imports: [...COMMON_MODULES],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss'
})
export class ErrorDialogComponent {

  mainClass = '';
  title = 'New Error';
  message = 'Some error occured';
  IMAGES_URL: string = IMAGES_URL + 'oops-icon.svg';
  imageWidth: number = 80;
  imageHeight: number = 80;
  imageClass: string = 'txt-center';  
  titleClass: string = 'txt-center';  
  messageClass: string = 'txt-center';  
  btnText: string = 'OKAY';

  @Output('onModalClose') modalClose: any = new EventEmitter();

  open() {
    $('#exampleModalError').modal('show');
  }

  saveAndClose() {
    this.modalClose.emit({});
  }
}
